import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { WorkspacesFiltersFormModel } from 'lib/forms/WorkspacesFiltersFormUtils'
import { toQueryParamsV2 } from 'lib/helpers/utilities'
import { IApiError } from 'services/Shared/shared.models'
import { getAllManagementWorkspaceRowIds } from 'services/Management/management.services'

const useGetAllManagementWorkspaceTableRowIds = (
  formValues: WorkspacesFiltersFormModel,
  onSuccess: () => void
): UseQueryResult<number[], IApiError> => {
  const query = useQuery<number[], IApiError>(
    ['getAllManagementWorkspaceTableRowIds', formValues],
    () => {
      const params = toQueryParamsV2(formValues)
      return getAllManagementWorkspaceRowIds(params)
    },
    {
      refetchOnWindowFocus: false,
      onSuccess: () => {
        onSuccess()
      },
    }
  )

  return query
}

export default useGetAllManagementWorkspaceTableRowIds
